import Flight from '@/views/Flight/index.vue'

const FlightRouter = {
  path: '/flight',
  name: 'Flight',
  component: Flight,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default FlightRouter
